import { TextField } from '@mui/material';
import './pages.css';

const FirstFitterPage = ({ handleChange, values, errors }) => {
	return (
		<>
			<img
				src="https://cdn.shopify.com/s/files/1/0604/8953/1530/files/measure_guide.jpg?v=1679265029"
				width="350"
			></img>
			<TextField
				label={ window.bra_calc_str.input_right_title }
				id="right-breast"
				placeholder={ window.bra_calc_str.input_right_placeholder }
				inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
				value={values.rightBreast}
				margin="normal"
				onChange={handleChange('rightBreast')}
				error={!!errors['rightBreast']}
				helperText={errors['rightBreast']}
				variant="outlined"
				required
			/>
			<TextField
				label={ window.bra_calc_str.input_left_title }
				id="left-breast"
				placeholder={ window.bra_calc_str.input_left_placeholder }
				inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
				value={values.leftBreast}
				onChange={handleChange('leftBreast')}
				margin="normal"
				error={!!errors['leftBreast']}
				helperText={errors['leftBreast']}
				variant="outlined"
				required
			/>
			<TextField
				label={ window.bra_calc_str.input_band_title }
				id="band-width"
				placeholder={ window.bra_calc_str.input_band_placeholder }
				inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
				value={values.bandSize}
				margin="normal"
				onChange={handleChange('bandSize')}
				error={!!errors['bandSize']}
				helperText={errors['bandSize']}
				variant="outlined"
				required
			/>
		</>
	);
};

export default FirstFitterPage;
